import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

export const COLUMNS = [
  {
    name: 'sector',
    title: 'Sector',
    className: alignStyles.alignLeft,
    width: 70,
  },
  {
    name: 'name',
    title: 'Name',
    className: alignStyles.alignLeft,
  },
  {
    name: 'strats',
    title: '',
    width: 70,
  },
  {
    name: 'filingDate',
    title: 'Filing Date',
    className: alignStyles.alignRight,
    width: 140,
  },
];
